const types = {
  CLEAR_CURRENT: 'ROLE_USERS_CLEAR_CURRENT',
  GET_REQUEST: 'ROLE_USERS_GET_REQUEST',
  GET_SUCCESS: 'ROLE_USERS_GET_SUCCESS',
  GET_FAILURE: 'ROLE_USERS_GET_FAILURE',

  SAVE_REQUEST: 'ROLE_USERS_SAVER_REQUEST',
  SAVE_SUCCESS: 'ROLE_USERS_SAVE_SUCCESS',
  SAVE_FAILURE: 'ROLE_USERS_SAVE_FAILURE',

  GETALL_REQUEST: 'ROLE_USERS_GETALL_REQUEST',
  GETALL_SUCCESS: 'ROLE_USERS_GETALL_SUCCESS',
  GETALL_FAILURE: 'ROLE_USERS_GETALL_FAILURE',

  DELETE_REQUEST: 'ROLE_USERS_DELETE_REQUEST',
  DELETE_SUCCESS: 'ROLE_USERS_DELETE_SUCCESS',
  DELETE_FAILURE: 'ROLE_USERS_DELETE_FAILURE',    

  UPDATE_REQUEST: 'ROLE_USERS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ROLE_USERS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ROLE_USERS_UPDATE_FAILURE'    

};

export default types;